/* eslint-disable prettier/prettier */
import ssf from '@elliemae/em-ssf-guest';
import { LoanTerm } from '@frontend/pricing-search';
import { LoanPurposeType, ProjectLegalStructureType } from './constants';

export const lookupType = <T extends Record<number, string>>(
  map: T,
  key: string,
  value: number,
) => {
  const result = map[value as keyof T];
  if (!result) return {};
  return { [key]: result };
};
// Omit null or undefined values from the payload
export const omitPropertyIfNullOrUndefined = (key: string, value: any) => {
  if (value === null || value === undefined) return {};
  return { [key]: value };
};

export const getEncompassClientAndUserId = async (): Promise<{
  clientId: string;
  encompassUserId: string;
}> => {
  const applicationObj = await ssf.getObject('application');
  const context = await applicationObj.performAction('getContext');
  return {
    clientId: context.clientId,
    encompassUserId: context.encompassUserId,
  };
};

export const getProjectLegalStructureType = (propertyType: number) =>
  lookupType(
    ProjectLegalStructureType,
    'projectLegalStructureType',
    propertyType,
  );

export const getConstructionMethodTypeOtherDescription = (
  propertyType: number,
) => {
  if (propertyType === 14)
    return { constructionMethodTypeOtherDescription: 'MHAdvantage' };
  return {};
};
export const getFinancedUnitCount = (propertyType: number): number => {
  return propertyType >= 1 && propertyType <= 4 ? propertyType : 1;
};
export const getLoanPurposeType = (
  loanPurpose: number,
  constructionRefinance: boolean,
) => {
  if (constructionRefinance) return { loanPurposeType: 'Refinance' };
  return lookupType(LoanPurposeType, 'loanPurposeType', loanPurpose);
};
export const getCreditReferenceType = (noCreditScores: boolean) => {
  if (!noCreditScores) return {};
  return { creditReferenceType: 'NonTraditional' };
};

export const getAmortizationType = (
  loanTerms: LoanTerm[],
  programTypeID: number | undefined,
): 'Fixed' | 'AdjustableRate' => {
  const term = (loanTerms ?? []).find((t) => t?.value === programTypeID);
  return term?.arm ? 'AdjustableRate' : 'Fixed';
};

export const shouldCalculateAPR = (clientSettings?: any): boolean => {
  const hasDisplayEstimatedAPR =
    clientSettings?.[0]?.options?.displayEstimatedAPR === true;
  const hasUseEncompassAPR =
    clientSettings?.[0]?.options?.useEncompassAPR === true;
  return hasDisplayEstimatedAPR && hasUseEncompassAPR;
};

export const getCeilingRatePercent = (lifetimeCap: number | undefined | null, rate:number) => {
  if (lifetimeCap === null || lifetimeCap === undefined) return {};
  return { ceilingRatePercent: rate + lifetimeCap };
};